export var BASKET_PAGE_HREF = '/cart';
export var FAVOURITES_PAGE_HREF = '/u/favourites';